module.exports = __webpack_public_path__ + "static/media/FreeSticker.42461a20.svg";